import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SoftwareCard from './SoftwareCard';
import { getCategories, getSoftwareByCategory } from '../data/softwareData';

const HomePage = () => {
  const categories = getCategories();
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);

  return (
    <div className="home-page">
      <header className="app-header">
        <h1>📥 软件下载中心</h1>
        <p>安全、快速、海量软件资源</p>
      </header>

      <div className="category-tabs">
        {categories.map(category => (
          <button
            key={category}
            className={`category-tab ${selectedCategory === category ? 'active' : ''}`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="category-content">
        <h2 className="category-title">{selectedCategory}</h2>
        <div className="software-grid">
          {getSoftwareByCategory(selectedCategory).map(software => (
            <SoftwareCard key={software.id} software={software} />
          ))}
        </div>
      </div>

      <footer className="app-footer">
        <p>© 2026 软件下载中心 | 所有软件均来自官方或可信来源</p>
        <div className="footer-links">
          <Link to="/navigation">网站导航</Link> | 
          <a href="#">联系我们</a> | 
          <a href="#">隐私政策</a> | 
          <a href="#">使用条款</a>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;